enum WalletName {
  Backpack = "Backpack",
  Glow = "Glow",
  Phantom = "Phantom",
  Solflare = "Solflare",
}

export default WalletName;
